import axios from 'axios';
import { getApiBaseUrl } from '../baseUrl';
import { LoginBackendResponse, LoginRequest } from '../../types/login/LoginResponse';

export interface LoginEmpresaRequest {
  cnpj: string;
  senha: string;
}

// Nova estrutura baseada na resposta JWT do backend
export interface EmpresaData {
  id: number;
  nome: string;
  cnpj: string;
  email: string;
  telefone?: string;
  endereco?: string;
  tipo: 'empresa';
}

export interface LoginEmpresaResponse {
  success: boolean;
  data: {
    accessToken: string;
    refreshToken: string;
    tokenType: string;
    expiresIn: number;
    user: EmpresaData;
  };
}

export interface LoginEmpresaError {
  message: string;
  statusCode: number;
  success: boolean;
}

export const loginEmpresa = async (credentials: LoginEmpresaRequest): Promise<LoginEmpresaResponse> => {
  const apiUrl = getApiBaseUrl();

  try {
    // Fazer chamada real para o endpoint de login do backend
    const loginPayload: LoginRequest = {
      cnpj: credentials.cnpj,
      senha: credentials.senha
    };

    const response = await axios.post<LoginBackendResponse>(
      `${apiUrl}/login`,
      loginPayload,
      {
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    );

    // Converter resposta do backend para o formato esperado pelo frontend
    const backendData = response.data;

    const loginResponse: LoginEmpresaResponse = {
      success: true,
      data: {
        accessToken: backendData.token,
        refreshToken: backendData.token, // Por enquanto usar o mesmo token
        tokenType: 'Bearer',
        expiresIn: 28800, // 8 horas em segundos
        user: {
          id: backendData.empresaId,
          nome: backendData.nomeEmpresa,
          cnpj: backendData.cnpj,
          email: backendData.email,
          telefone: backendData.telefone,
          tipo: 'empresa'
        }
      }
    };

    return loginResponse;
    
  } catch (error: any) {
    console.error('Erro no login:', error);

    // Tratar erros do backend
    if (error.response) {
      const status = error.response.status;
      const message = error.response.data?.message;

      if (status === 401) {
        throw new Error(message || 'CNPJ ou senha incorretos');
      } else if (status === 403) {
        throw new Error(message || 'Empresa está inativa');
      } else if (status === 404) {
        throw new Error('Endpoint de login não encontrado');
      } else {
        throw new Error(message || 'Erro ao fazer login');
      }
    }

    // Erro de rede/CORS
    if (error.code === 'ERR_NETWORK' || error.message.includes('CORS')) {
      throw new Error('Erro de conexão com o servidor. Verifique se o backend está rodando e configurado para aceitar requisições do frontend.');
    }

    throw new Error('Erro ao conectar com o servidor');
  }
};